import { Event } from "event-source-polyfill";
import { Dispatch, SetStateAction } from "react";

import { IMessage } from "@pages/Technology/components/TechnologyMarketingSummary";

interface IHandleEventListener {
  setIsLoading: Dispatch<SetStateAction<boolean>>;
  setMessages: Dispatch<SetStateAction<IMessage[]>>;
}

export const handleEventListener =
  ({ setIsLoading, setMessages }: IHandleEventListener) =>
  (event: Event | MessageEvent) => {
    setIsLoading(false);

    const newEvent = event as { data: string; id?: string; retry?: number; type?: string };

    if (!newEvent.data) return;

    const response = newEvent.data;

    if (response) {
      setMessages((previousMessages) => {
        const lastMessage = previousMessages.at(-1) || { content: "", id: Date.now().toString(), role: "user" };

        // If last message was from assistant, append to it
        if (lastMessage.role === "assistant") {
          const updatedMessages = [...previousMessages];
          updatedMessages[updatedMessages.length - 1] = {
            ...lastMessage,
            content: lastMessage.content + response,
          };
          return updatedMessages;
        }

        // If last message was from user, create new assistant message
        return [...previousMessages, { content: response, id: Date.now().toString(), role: "assistant" }];
      });
    }
  };
